export default __webpack_public_path__ + "static/media/p-.xyz_logo.88298d23.png";